import * as types from '../mutation-types'

export default {
    namespaced: true,

    state:{
        weightAndQualities: []
    },

    actions:{
        fetchAll({ commit }, { date }){
            return window.axios.get('/files/weightAndQuality', {
                params:{
                    date
                }
            })
            .then((response) => {
                commit(types.STORE_WEIGHT_AND_QUALITY, response.data);
                return response.data;
            })
        },

        fetchById({ commit }, { id }){
            return window.axios.get(`/files/weightAndQuality/${id}`)
            .then((response) => {
                return response.data;
            })
        },

        create({ commit }, { date, invoiceNumber, contractNumber, exporter, consignee, multiNotes, cargoDescription, placeOfOrigin, placeOfLoading, placeOfDestination, description, containerNumber, sealNumber, billOfLadingNumber, items }){
            return window.axios.post('/files/weightAndQuality', { date, invoiceNumber, contractNumber, exporter, consignee, multiNotes, cargoDescription, placeOfOrigin, placeOfLoading, placeOfDestination, description, containerNumber, sealNumber, billOfLadingNumber, items })
            .then((response) => {
                return response.data;
            });
        },

        update({ commit }, { id, date, invoiceNumber, contractNumber, exporter, consignee, multiNotes, cargoDescription, placeOfOrigin, placeOfLoading, placeOfDestination, description, containerNumber, sealNumber, billOfLadingNumber, items }){
            return window.axios.put(`/files/weightAndQuality/${id}`, { date, invoiceNumber, contractNumber, exporter, consignee, multiNotes, cargoDescription, placeOfOrigin, placeOfLoading, placeOfDestination, description, containerNumber, sealNumber, billOfLadingNumber, items })
            .then((response) => {
                return id;
            });
        },

        delete({ commit }, { id }){
            return window.axios.delete(`/files/weightAndQuality/${id}`);
        }
    },

    mutations:{
        [types.STORE_WEIGHT_AND_QUALITY](state, weightAndQualities){
            state.weightAndQualities = weightAndQualities;
        }
    },

    getters:{
        getWeightAndQualityById: state => id => state.weightAndQualities.find(c => c.id === id),
    }
}